import Bag from '@assets/icons/bag.svg'
import { Icon } from './Icon'

export const BagIcon = Icon(Bag)
